/** Fonction that return the fomatted amount to be displayed 
 * to end users
 */

import currency from "currency.js"

const getFormattedAmount = (amount) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(currency(amount).divide(100).value);
};

export default getFormattedAmount